import { css } from '@styled-system/css'
import React, { useEffect, useState } from 'react'
import styledComponents from 'styled-components'
import { Box } from 'ui/acro'
import AloMovesAnimation from '../common/AloMovesAnimation'
import TopResultsSectionHeader, {
  ResultsCount
} from '../common/TopResultsSectionHeader'
import ClassResultsCarousel from '../TopResultsCarousels/ClassResultsCarousel'
import InstructorsResultsCarousel from '../TopResultsCarousels/InstructorResultsCarousel'
import PlaylistsResultsCarousel from '../TopResultsCarousels/PlaylistsResultsCarousel'
import SeriesResultsCarousel from '../TopResultsCarousels/SeriesResultCarousel'
import { axios } from 'api'

const TopResultsSection = styledComponents(Box)`
${css({
  pb: ['37px', '46px', '46px', '57px']
})}`

const TopResultsPage = ({ query }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  useEffect(() => {
    setLoading(true)
    axios
      .get(`/search/results?q=${query}`)
      .then((res) => {
        setData(res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [query])
  if (data && !loading) {
    return (
      <Box mt='17px'>
        <ResultsCount pb='17px'>
          {data.totalResultsReturned}{' '}
          {data.totalResultsReturned !== 1 ? `results` : `result`}
        </ResultsCount>
        {data.instructors.resultCount >= 1 && (
          <TopResultsSection>
            <TopResultsSectionHeader
              title='Instructors'
              count={data.instructors.resultCount}
              onClick={() => {
                document.getElementById('Search-tab-instructors').click()
              }}
            />
            <InstructorsResultsCarousel data={data} />
          </TopResultsSection>
        )}
        {data.classes.resultCount >= 1 && (
          <TopResultsSection>
            <TopResultsSectionHeader
              title='Classes'
              count={data.classes.resultCount}
              onClick={() => {
                document.getElementById('Search-tab-classes').click()
              }}
            />
            <ClassResultsCarousel data={data} />
          </TopResultsSection>
        )}
        {data.series.resultCount >= 1 && (
          <TopResultsSection>
            <TopResultsSectionHeader
              title='Programs'
              count={data.series.resultCount}
              onClick={() => {
                document.getElementById('Search-tab-programs').click()
              }}
            />
            <SeriesResultsCarousel data={data} />
          </TopResultsSection>
        )}
        {data.playlists.resultCount >= 1 && (
          <TopResultsSection>
            <TopResultsSectionHeader
              title='Playlists'
              count={data.playlists.resultCount}
              onClick={() => {
                document.getElementById('Search-tab-playlists').click()
              }}
            />
            <PlaylistsResultsCarousel data={data} />
          </TopResultsSection>
        )}
      </Box>
    )
  } else if (!data || loading) {
    return <AloMovesAnimation />
  }
}

export default TopResultsPage
